const reggie = {
    formatPhone: (input: string) => {//returns string
        let cleaned = ('' + input).replace(/\D/g, '')
        let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            let intlCode = (match[1] ? '+1 ' : '')
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        }
        return null
    },
    validateMail: (mail: string) => {//returns boolean
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(mail).toLowerCase())
    },
    validatePhone: (phone: string) => {
        //r-18-lint-bk
        //eslint-disable-next-line
        const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
        return re.test(String(phone).toLowerCase())
    },
    formatThousands: (number: number) => {//returns string
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    cleanLines: (str: string) => {//returns string
        return str.replace(/^\s*[\r\n]/gm, "")
    },
    deCamel: (str: string) => {//returns a string split by uppercase letters
        return str.replace(/([a-z])([A-Z])/g, '$1 $2')
    },
    deKebab: (str: string) => {//returns a string split by hyphens
        return str.replace(/-/g, ' ')
    },
    joinString: (str: string) => {
        return str.replace(/\s+/g, '')
    },
    getFileExtensionFromString: (str: string) => {
        const re = /(?:\.([^.]+))?$/
        //@ts-ignore
        let extension = re.exec(str)[1]
        if (extension) {
            return extension
        }
        return null
    },
    filterTags: (str: string | null) => {
        if (str) {
            return str.replace(/<(.|\n)*?>/g, "").trim()
        }
        return null
    }
}
export default reggie